export default (theme) => ({
    container: {
        marginTop: '25px',
        background: 'white',
        boxShadow: '0px 3px 10px rgba(0, 0, 0, 0.15)',
        borderRadius: '8px',
        padding: '10px 27px 20px 27px',
    },

    tituloSeccion: {
        fontSize: '14px',
        lineHeight: '26px',
        color: '#011328',
    },

    containerTitulo: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },

    ayuda: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: '7px',
        fontWeight: 'bold',
        fontSize: '10px',
        lineHeight: '9px',
        width: '16px',
        height: '16px',
        borderRadius: '8px',
        background: '#727A94',
        color: 'white',
    },
    
});
